@if (isLoading) {
    <ui-loader></ui-loader>
}

<div class="container-wrap">
    <div class="header text-centered">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="93"
            height="100"
            viewBox="0 0 93 100"
            fill="none">
            <path
                d="M35.0335 54.5805C39.3754 42.8953 37.1224 25.2413 8.68378 0C8.02727 22.2717 7.78854 38.9013 10.0117 49.5471C6.29396 55.1894 2.94964 61.0667 0 67.1418C11.3546 72.4276 25.1561 78.5449 32.2135 63.4002C28.9459 73.4076 31.7659 84.395 50.1182 100C53.177 93.7342 59.1601 80.1485 59.9807 69.4135C71.5691 62.0759 82.6047 53.9078 93 44.974C68.8436 36.9562 44.7618 32.977 35.0335 54.5805Z"
                fill="url(#paint0_linear_9299_457)" />
            <defs>
                <linearGradient
                    id="paint0_linear_9299_457"
                    x1="46.4925"
                    y1="0"
                    x2="46.4925"
                    y2="100"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#01A1FE" />
                    <stop
                        offset="1"
                        stop-color="#0058FF" />
                </linearGradient>
            </defs>
        </svg>

        <h1 class="title">Welcome to Bannerflow</h1>
    </div>

    @if (!isLoading) {
        <div class="container">
            <form
                class="form__content"
                novalidate="novalidate"
                (keyup.enter)="onSubmit()"
                [formGroup]="newUserForm">
                <div class="row">
                    <div class="column columnHalf">
                        <ui-input
                            [label]="'First name'"
                            [isRequired]="true"
                            formControlName="givenName"
                            id="givenName"
                            name="givenName"
                            placeholder="Enter your first name"
                            [validation]="newUserForm.controls.givenName"></ui-input>
                        @if (
                            newUserForm.controls.givenName.value.length > 0 &&
                            newUserForm.controls.givenName.value.length < 2
                        ) {
                            <div class="error__message">
                                <ui-label
                                    [type]="'destructive'"
                                    size="xs"
                                    leadingIcon="error"
                                    >Should contain at least two letters</ui-label
                                >
                            </div>
                        }
                    </div>
                    <div class="column columnHalf">
                        <ui-input
                            [label]="'Last name'"
                            [isRequired]="true"
                            formControlName="familyName"
                            id="familyName"
                            name="familyName"
                            placeholder="Enter your last name"
                            [validation]="newUserForm.controls.familyName"></ui-input>
                        @if (
                            newUserForm.controls.familyName.value.length > 0 &&
                            newUserForm.controls.familyName.value.length < 2
                        ) {
                            <div class="error__message">
                                <ui-label
                                    [type]="'destructive'"
                                    size="xs"
                                    leadingIcon="error"
                                    >Should contain at least two letters</ui-label
                                >
                            </div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="column columnHalf">
                        <ui-input
                            [label]="'Email'"
                            [disabled]="true"
                            formControlName="email"
                            id="email"
                            name="email"></ui-input>
                    </div>
                    <div class="column columnHalf">
                        @if (isUserTitlesLoaded) {
                            <div class="title-selection">
                                <ui-select
                                    [label]="'Title'"
                                    [isRequired]="true"
                                    id="select-theme"
                                    placeholder="Select your title"
                                    [width]="'100%'"
                                    [useTargetWidth]="true"
                                    [(selected)]="selectedUserTitle">
                                    @for (userTitle of userTitles; track userTitle.id) {
                                        <ui-option [value]="userTitle">{{ userTitle.title }}</ui-option>
                                    }
                                </ui-select>
                                <span
                                    class="title-help"
                                    uiTooltip="Your title is required in order for our support team to help you in the most efficient way and to give you suggestions on webinars or other things that might be relevant for you. Please select the closest title if your exact title is not presented in the list.">
                                    Why we need this?
                                </span>
                            </div>
                        } @else {
                            <div class="loading-item titles">Loading titles...</div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <ui-select
                            [label]="'Time zone'"
                            id="select-theme"
                            [searchable]="true"
                            [width]="'100%'"
                            [useTargetWidth]="true"
                            [(selected)]="user.timeZone">
                            @for (itm of timeZones; track itm.id) {
                                <ui-option [value]="itm.id">{{ itm.displayName }}</ui-option>
                            }
                        </ui-select>
                    </div>
                </div>
                @if (isPasswordUser) {
                    <!-- fs-mask: the eye icon swaps these inputs to type="text", which Form Privacy
                         only masks by default. Masking rather than excluding keeps the clicks and
                         focus events on these fields, which this funnel exists to record. -->
                    <div class="password-container fs-mask">
                        <ui-input
                            [isRequired]="true"
                            [nuiSvgIcon]="displayPassword ? 'visibility_off' : 'visibility'"
                            [label]="'Password'"
                            formControlName="password"
                            id="password"
                            name="password"
                            [type]="displayPassword ? 'text' : 'password'"
                            placeholder="Create a password"
                            [validation]="newUserForm.controls.password"
                            (clickIcon)="showPassword()"
                            (click)="onPasswordEvents('password', passwordTarget, popover)"
                            (focus)="onPasswordEvents('password', passwordTarget, popover)"
                            (valueChange)="onPasswordEvents('password', passwordTarget, popover)"
                            ui-popover-target
                            #passwordTarget="ui-popover-target">
                        </ui-input>
                        <ui-input
                            [isRequired]="true"
                            [nuiSvgIcon]="displayPassword ? 'visibility_off' : 'visibility'"
                            [label]="'Confirm password'"
                            formControlName="passwordConfirmation"
                            id="passwordConfirmation"
                            name="passwordConfirmation"
                            [type]="displayPassword ? 'text' : 'password'"
                            placeholder="Enter your password again"
                            [validation]="newUserForm.controls.passwordConfirmation"
                            (clickIcon)="showPassword()"
                            (click)="
                                onPasswordEvents('passwordConfirmation', confirmPasswordTarget, popover)
                            "
                            (focus)="
                                onPasswordEvents('passwordConfirmation', confirmPasswordTarget, popover)
                            "
                            (valueChange)="
                                onPasswordEvents('passwordConfirmation', confirmPasswordTarget, popover)
                            "
                            ui-popover-target
                            #confirmPasswordTarget="ui-popover-target"></ui-input>
                    </div>
                }
                <div class="action">
                    <div class="row policy">
                        <ui-checkbox [(selected)]="user.acceptsToC"></ui-checkbox>
                        <span class="checkbox-text"
                            >I accept the
                            <ui-link
                                [size]="'sm'"
                                href="https://bannerflow.com/privacy"
                                tabindex="-1"
                                target="_blank"
                                title="Privacy policy">
                                privacy policy
                            </ui-link>
                        </span>
                        @if (!user.acceptsToC && submitTouched) {
                            <div class="error__message">
                                <span
                                    >Accepting Terms of Conditions and Privacy policy is required.</span
                                >
                            </div>
                        }
                    </div>
                    <ui-button
                        class="button--wide"
                        text="Sign up"
                        type="primary"
                        (click)="onSubmit()"
                        [disabled]="
                            newUserForm.invalid || !user.acceptsToC || !selectedUserTitle
                        "></ui-button>
                </div>
                <ui-popover
                    #popover="ui-popover"
                    [config]="uiPopoverConfig">
                    <ng-template ui-popover-template>
                        <app-password-requirements
                            [checklist]="shownPasswordRequirements"
                            [passwordRequirements]="passwordRequirements"></app-password-requirements>
                    </ng-template>
                </ui-popover>
            </form>
        </div>
    }
</div>
